import { portfolioItemTypes } from 'shared/constants/portfolio/portfolioItemTypes';
import { ratingTypes } from 'shared/constants/ratingTypes';
import { instrumentsToTableParser } from '../instrumentsToTable/instrumentsToTableParser';
import { entitiesToTableParser } from '../entitiesToTable/entitiesToTableParser';
import { creditReviewListToTableParser } from '../creditReviewToTable/creditReviewToTableParser';
import { esgImpactToTableParser } from '../esgImpactToTable/esgImpactToTableParser';
import { esgSentimentToTableParser } from '../esgSentimentToTable/esgSentimentToTableParser';

const entityByRatingTypeParser = {
  [ratingTypes.CREDIT_RATING]: entitiesToTableParser,
  [ratingTypes.CREDIT_REVIEW]: creditReviewListToTableParser,
  [ratingTypes.ESG_IMPACT]: esgImpactToTableParser,
  [ratingTypes.SENTIMENT]: esgSentimentToTableParser,
};

const getItemTypesToParsers = (itemsType, ratingType) => {
  const parsers = {
    [portfolioItemTypes.INSTRUMENT]: instrumentsToTableParser,
    [portfolioItemTypes.ENTITY]: entityByRatingTypeParser[ratingType],
    [portfolioItemTypes.RATING_NEWS]: null,
    [portfolioItemTypes.RESEARCH]: null,
    [portfolioItemTypes.COMMENTARY]: null,
    [portfolioItemTypes.COMPANY_NEWS]: null,
  };

  return parsers[itemsType];
};

export const dossierItemsToTableParser = (
  data,
  itemsType,
  ratingType = ratingTypes.CREDIT_RATING,
) => {
  const parser = getItemTypesToParsers(itemsType, ratingType);
  return parser ? parser(data) : data;
};
